import styled from 'styled-components';
import { DESKTOP_WIDTH, TABLET_WIDTH, MOBILE_WIDTH } from '../../globalUtils';
import { ReactComponent as TimerSVG } from '../../../icons/Timer.svg';
import { ReactComponent as HomeSVG } from '../../../icons/Home.svg';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const TopText = styled.div`
    color: #003a70;
    text-align: center;
    font-size: 18px;
    width: 1029px;
    margin-bottom: 99px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 16px;
        width: 707px;
        margin-bottom: 49px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 16px;
        width: 315px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        font-size: 14px;
        width: 280px;
    }
`;


export const Types = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 100px;

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        flex-direction: column;
    }
`;

export const Type = styled.div`
    height: 243px;
    padding-top: 26px;
    width: 280px;
    background-color: #ffffff;
    margin: 0 65px;
    border-radius: 50px 15px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        margin: 11px 0;
    }
`;

export const Timer = styled(TimerSVG)`
    height: 49px;
    width: 51px;
`;

export const Home = styled(HomeSVG)`
    height: 44px;
    width: 50px;
`;

export const TypeTitle = styled.div`
    color: #ff4438;
    font-size: 26px;
    margin-bottom: 34px;
`;

export const TypeText = styled.div`
    color: #003a70;
    text-align: center;
    font-size: 18px;
    width: 220px;
`;

export const Cta = styled.div`
    cursor: pointer;
    height: 59px;
    width: 322px;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    color: #f1efef;
    text-align: center;
    font-size: 23px;
    display: flex;
    background-color: #ff4438;
    justify-content: center;
    align-items: center;

    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        height: 38px;
        width: 284px;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.5);
        font-size: 14px;
    }
`;
